import { render, staticRenderFns } from "./FilterTanawariPattern.vue?vue&type=template&id=13fc0c9a&scoped=true&"
import script from "./FilterTanawariPattern.vue?vue&type=script&lang=js&"
export * from "./FilterTanawariPattern.vue?vue&type=script&lang=js&"
import style0 from "./FilterTanawariPattern.vue?vue&type=style&index=0&id=13fc0c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fc0c9a",
  null
  
)

export default component.exports